// @flow
import * as React from 'react';

import styles from './ECartItemTitle.module.scss';;


type Props = {
  children: React.Node,
  htmlFor?: string,
}

const ECartItemTitle = ({ children, htmlFor }: Props) => (
  <div className={styles.root}>
    {children}
    {htmlFor
      && <label // eslint-disable-line jsx-a11y/label-has-associated-control
        className={styles.label}
        htmlFor={htmlFor}
      />}
  </div>
);

export default ECartItemTitle;
